function hashStr(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

function rootLabel(domain: string): string {
  const parts = domain.split(".").filter(Boolean);
  const noWww = parts[0] === "www" ? parts.slice(1) : parts;
  if (noWww.length === 0) return domain;
  return noWww[Math.max(0, noWww.length - 2)];
}

export function identiconBackground(seed: string): string {
  return `hsl(${hashStr(seed || "x") % 360}, 55%, 38%)`;
}

export function identiconLetter(seed: string): string {
  const r = rootLabel(seed || "?");
  for (const c of r) if (/[a-zA-Z0-9]/.test(c)) return c.toUpperCase();
  return "?";
}

interface Props {
  seed: string;
  size?: number;
}

export function Identicon({ seed, size = 40 }: Props) {
  return (
    <div
      className="identicon"
      style={{
        background: identiconBackground(seed),
        width: size,
        height: size,
        fontSize: Math.round(size * 0.45),
      }}
      aria-hidden="true"
    >
      {identiconLetter(seed)}
    </div>
  );
}
